import {
  GET_CHANNELS_ATTEMPT,
  GET_CHANNELS_SUCCESS,
  GET_CHANNELS_FAILURE,
} from "../constants";

import { ChannelsInitialState } from "../../types/channels";

const initialState: ChannelsInitialState = {
  fetchingChannelsList: 0,
  errorMessage: "",
  success: true,
  channelsList: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getChannels
    case GET_CHANNELS_ATTEMPT:
      return {
        ...state,
        fetchingChannelsList: state.fetchingChannelsList + 1,
        success: true,
        errorMessage: "",
      };
    case GET_CHANNELS_SUCCESS:
      return {
        ...state,
        fetchingChannelsList: state.fetchingChannelsList - 1,
        success: true,
        errorMessage: "",
        channelsList: validData(action.payload.data),
      };
    case GET_CHANNELS_FAILURE:
      return {
        ...state,
        fetchingChannelsList: state.fetchingChannelsList - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};

function validData (data: any[]) {
  return data.filter((element: any) => element.clientChannel)
}